import { render, staticRenderFns } from "./MemosRecordedView.vue?vue&type=template&id=1d5b6c94&scoped=true&"
import script from "./MemosRecordedView.vue?vue&type=script&lang=ts&"
export * from "./MemosRecordedView.vue?vue&type=script&lang=ts&"
import style0 from "./MemosRecordedView.vue?vue&type=style&index=0&id=1d5b6c94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5b6c94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/a/1/s/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
installComponents(component, {VAlert})
